export const Tx = {
    /**
     * TX_INITIATE
     */
    // Actions on initiation settings
    SET_INITIATE_CPTY: "tx.initiate.set_cpty",
    SET_INITIATE_COMMENT: "tx.initiate.set.comment",
    UPDATE_AC: "tx.initiate.ac.edit",

    // LocalStorage for AC
    AC_STORAGE_VALUE: "tx.initiate.ac.storage.value",
    AC_STORAGE_TOGGLE: "tx.initiate.ac.storage.toggle",
    FUND_CODE_STORAGE_VALUE: "tx.initiate.fund_code.storage.value",

    // Actions on initiation preview table
    RESET_INIT: "tx.initiate.table.reset",
    PREPARE_INIT: "tx.initiate.table.prepare",
    UPDATE_INIT_ROW: "tx.initiate.table.row.update",
    DELETE_INIT_ROW: "tx.initiate.table.row.delete",
    ATTACH_INVENTORY: "tx.initiate.table.attach.inventory",

    // Actions on posting initiatoin
    SEND_INIT: "tx.initiate.send",
    INIT_ERROR: "tx.initiate.error",
    INIT_SENT: "tx.initiate.sent",
    CANCEL_SEND: "tx.initiate.send.cancel",

    // Actions on Offer settings
    SET_OFFER_SETTINGS: "tx.offer.set.settings",
    SET_OFFER_COMMENT: "tx.offer.set.comment",

    // Actions on Request settings
    SET_REQUEST_SETTINGS: "tx.request.set.settings",

    // Actions on initiation market data
    GET_MARKET_DATA: "tx.initiate.get_market",
    EDIT_MARKET_DATA: "tx.initiate.edit_market",

    REPORT_MD_ERROR: "tx.initiate.report_market_error",
    /**
     * TX_LIST
     */
    UPDATE_BORROW_LIST: "tx.borrow.list.update",
    UPDATE_LEND_LIST: "tx.lend.list.update",
    UPDATE_BORROW_LIST_UI_EDIT: "tx.borrow.list.update.ui",
    UPDATE_LEND_LIST_UI_EDIT: "tx.lend.list.update.ui",

    /**
     * TX_RESPOND
     */
    SET_RESPOND_COMMENT: "tx.respond.set_comment",
    SEND_RESPOND: "tx.respond.send",
    RESPOND_ERROR: "tx.respond.error",
    RESPOND_SENT: "tx.respond.sent",
    /**
     * Event actions
     */
    UPDATE_TX_STATE: "tx.update.state",
    UPDATE_TX_STATE_LIST: "tx.update.state.list",
    INSERT_BORROW_TX_LIST: "tx.insert.borrow.list",
    INSERT_LEND_TX_LIST: "tx.insert.lend.list",
    UPDATE_TX_BORROW_ENTRIES: "tx.update.borrow.entries",
    UPDATE_TX_LEND_ENTRIES: "tx.update.lend.entries",

    APPLY_REF_RATE: "tx.apply.ref_rate",
    APPLY_MATURITY: "tx.apply.maturity",
    APPLY_TX_TYPE: "tx.apply.tx_type",
    APPLY_INTERMEDIARY: "tx.apply.intermediary",
    APPLY_SEND_OFFER_DETAILS: "tx.apply.send_offer_details",

    SET_CPTY_ERROR: "tx.set.cpty.error",

    SET_HIDE_INACTIVE: "tx.set.hide_inactive",

    /**
     * Tables
     */
    SET_SELECTED_SECURITY: "tx.set.selected_security", //for reference data
    SET_SELECTED_ROWS: "tx.set.selected_rows",
    SET_SELECTED_ROW_TYPE: "tx.set.selected_row_type",
    SET_SELECTED_ROW_INFO: "tx.set.selected_row_info",
};
